
const initTeamSearch = () => {
  const teamContainer = document.querySelector("#team-filter-container");

  if (!teamContainer) {
    return;
  }

  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const teamRestBase = protocol + '//' + hostname + '/wp-json/team-rest/v1';
  const searchButton = document.querySelector('#search-team');
  const dropdownItems = document.querySelectorAll('.filter-item button');
  const clearBtn = document.querySelector('#clear-team-search');
  const noResultsMessage = document.querySelector('#no-results-message');
  const alphabetSearch = document.querySelectorAll('.alpha-btn.has-post');
  const searchInput = document.querySelector('input[name="search-input"]');
  const url = new URL(window.location.href);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let areaPracticeFilter = urlParams.get('area-practice');
  let roleFilter = urlParams.get('role');
  let admissionFilter = urlParams.get('admission');

  document.addEventListener("DOMContentLoaded", () => {
    if (areaPracticeFilter) {
      const areaPracticeValue = document.querySelector('.filter-item button[data-id="' + areaPracticeFilter + '"][data-type="area-practice"]');
      if (areaPracticeValue) {
        const text = areaPracticeValue.textContent;
        document.querySelector('.choose-button[data-id="area-practice"]').textContent = text;
        document.querySelector('.choose-button[data-id="area-practice"]').dataset.value = areaPracticeFilter; 
      }
    }

    if (roleFilter) {
      const roleValue = document.querySelector('.filter-item button[data-id="' + roleFilter + '"][data-type="role"]');
      if (roleValue) {
        const text = roleValue.textContent;
        document.querySelector('.choose-button[data-id="role"]').textContent = text;
        document.querySelector('.choose-button[data-id="role"]').dataset.value = roleFilter; 
      }
    }

    if (admissionFilter) {
      const admissionValue = document.querySelector('.filter-item button[data-id="' + admissionFilter + '"][data-type="admission"]');
      if (admissionValue) {
        const text = admissionValue.textContent;
        document.querySelector('.choose-button[data-id="admission"]').textContent = text;
        document.querySelector('.choose-button[data-id="admission"]').dataset.value = admissionFilter;
      }
    }
  });

  // GET TEAM RESULTS
  const getTeamResults = (area_practice, role, admission, letter, keywords) => {

    let data = {
      'action' : 'team_rest',
      area_practice: area_practice,
      role: role,
      admission: admission,
      letter: letter,
      keywords: keywords
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'X-WP-Nonce': team_rest.apiNonce,
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        data: data,
      }),
    };

    fetch(teamRestBase + '/search?date=' + Date.now(), options)
      .then((response) => {
        if (!response.ok) {
          const statusError = 'Error getting Search from API';
          if (response.status === 403) {
            console.log('Nonce Error');
          }
          throw new Error(statusError);
        } else {
          return response.json();
        }
      })
      .then((response) => {
        if (response && response.posts !== '') {
          teamContainer.innerHTML = response.posts;
          noResultsMessage.style.display = 'none';
        } else {
          teamContainer.innerHTML = '';
          noResultsMessage.style.display = 'block';
        }

        if (response && response.facets) {
          applyFacetDisabling(response.facets);
          normalizeCurrentSelections();
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  document.querySelectorAll('.uk-dropdown-nav').forEach(ul => {
    ul.addEventListener('click', (e) => {
      const item = e.target.closest('button[data-type]');
      if (!item) return;
      applySelection(item);
    });

    ul.addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('button[data-type]')) {
        e.preventDefault();
        applySelection(e.target);
      }
    });
  });

  function applySelection(item) {
    const selectedCategory = item.dataset.id || '';
    const dropdownType     = item.dataset.type;
    const selectedText     = item.textContent.trim();

    const trigger = document.querySelector(`.choose-button[data-id="${dropdownType}"]`);
    if (!trigger) return;

    trigger.textContent = selectedText;
    trigger.dataset.value = selectedCategory;

    const dropEl = item.closest('[uk-dropdown]') || item.closest('.uk-dropdown, .uk-drop');
    if (dropEl && window.UIkit && UIkit.dropdown) {
      UIkit.dropdown(dropEl).hide(false);
    } else if (dropEl) {
      dropEl.classList.remove('uk-open');
      dropEl.hidden = true;
    }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
  }

  alphabetSearch.forEach(button => {
    button.addEventListener("click", () => {
      let selectedLetter = button.dataset.letter;

      alphabetSearch.forEach(btn => btn.classList.remove('selected'));
      button.classList.add('selected');

      let selectedAreaPractice = document.querySelector('.choose-button[data-id="area-practice"]').dataset.value;
      let selectedRole = document.querySelector('.choose-button[data-id="role"]').dataset.value;
      let selectedAdmission = document.querySelector('.choose-button[data-id="admission"]').dataset.value;
      let keywords = document.querySelector('.search-input').value;

      getTeamResults(selectedAreaPractice, selectedRole, selectedAdmission, selectedLetter, keywords);
      clearBtn.style.display = 'inline-block';
    });
  });

  if (searchButton) {
    searchButton.addEventListener("click", () => {
        let selectedAreaPractice = document.querySelector('.choose-button[data-id="area-practice"]').dataset.value;
        let selectedRole = document.querySelector('.choose-button[data-id="role"]').dataset.value;
        let selectedAdmission = document.querySelector('.choose-button[data-id="admission"]').dataset.value;
        let selectedLetter = document.querySelector('.alpha-btn.selected') ? document.querySelector('.alpha-btn.selected').dataset.letter : '';
        let keywords = document.querySelector('.search-input').value;

        if (typeof selectedAreaPractice === 'undefined') {
          selectedAreaPractice = '';
        }

        if (typeof selectedRole === 'undefined') {
          selectedRole = '';
        }

        if (typeof selectedAdmission === 'undefined') {
          selectedAdmission = '';
        }

        getTeamResults(selectedAreaPractice, selectedRole, selectedAdmission, selectedLetter, keywords);
        clearBtn.style.display = 'inline-block';
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      document.querySelector('.search-input[name="search-input"]').value = '';

      const areaPracticeBtn = document.querySelector('.choose-button[data-id="area-practice"]');
      if (areaPracticeBtn) {
        areaPracticeBtn.textContent = 'Area of Practice';
        areaPracticeBtn.dataset.value = '';
      }

      const roleBtn = document.querySelector('.choose-button[data-id="role"]');
      if (roleBtn) {
        roleBtn.textContent = 'Role';
        roleBtn.dataset.value = '';
      }

      const admissionBtn = document.querySelector('.choose-button[data-id="admission"]');
      if (admissionBtn) {
        admissionBtn.textContent = 'Admission';
        admissionBtn.dataset.value = '';
      }

      alphabetSearch.forEach(btn => btn.classList.remove('selected'));

      clearBtn.style.display = 'none';

      getTeamResults('', '', '', '', '');

      url.searchParams.delete("area-practice");
      url.searchParams.delete("role");
      url.searchParams.delete("admission");

      let newUrlString = [];
      newUrlString = url
        .toString();

      window.history.pushState(null, null, newUrlString);
      window.location.reload();
    });
  }

  function setOptionDisabled(btn, disabled) {
    if (disabled) {
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      btn.classList.add('uk-disabled');
      btn.tabIndex = -1;
    } else {
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      btn.classList.remove('uk-disabled');
      btn.removeAttribute('tabindex');
    }
  }

  function applyFacetDisabling(facets) {
    document.querySelectorAll('.uk-dropdown-nav .filter-item button[data-type]').forEach(btn => {
      const type = btn.dataset.type;
      const id   = btn.dataset.id;
      
      const map = {
        'area-practice': 'area_practice',
        'role': 'role',
        'admission': 'admission'
      };
      const facetKey = map[type];
      if (!facetKey || !facets || !facets[facetKey]) return;

      const count = facets[facetKey][id] || 0;
      setOptionDisabled(btn, count === 0);
    });
  }

  function normalizeCurrentSelections() {
    ['area-practice','role','admission'].forEach(type => {
      const trigger = document.querySelector(`.choose-button[data-id="${type}"]`);
      if (!trigger) return;
      const val = trigger.dataset.value || '';
      if (!val) return;

      const selectedBtn = document.querySelector(`.uk-dropdown-nav .filter-item button[data-type="${type}"][data-id="${val}"]`);
      if (selectedBtn && selectedBtn.disabled) {
        const defaults = {
          'area-practice': 'Area of Practice',
          'role': 'Role',
          'admission': 'Admission'
        };
        trigger.textContent = defaults[type] || 'Choose';
        trigger.dataset.value = '';
      }
    });
  }

  if (searchInput && searchButton) {
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchButton.click();
      }
    });
  }

};

export default initTeamSearch;
